// extracted by mini-css-extract-plugin
export default {"root":"activity_status_badge-module___root___a64c8521","icon":"activity_status_badge-module___icon___b806cda0"};